// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"a0324d9e","453":"9f9f6189"}[chunkId] + ".chunk.js";
};